module.exports = __webpack_public_path__ + "static/img/name4.49bcd86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cn/name4.png
// module id = L82T
// module chunks = 1